import { render, staticRenderFns } from "./Norditropin.vue?vue&type=template&id=6297dca9&scoped=true&"
import script from "./Norditropin.vue?vue&type=script&lang=js&"
export * from "./Norditropin.vue?vue&type=script&lang=js&"
import style0 from "./Norditropin.vue?vue&type=style&index=0&id=6297dca9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6297dca9",
  null
  
)

export default component.exports